import { render, staticRenderFns } from "./demandOne.vue?vue&type=template&id=09f5bea6&scoped=true"
import script from "./demandOne.vue?vue&type=script&lang=js"
export * from "./demandOne.vue?vue&type=script&lang=js"
import style0 from "./demandOne.vue?vue&type=style&index=0&id=09f5bea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f5bea6",
  null
  
)

export default component.exports